module.exports = __webpack_public_path__ + "static/media/Roast_Potato.82c37f4f.webp";